<ion-card
  class="delay-10 !m-0 size-full transition ease-in-out hover:scale-[103%] flex flex-col"
  [routerLink]="productDetailsRouterLink()"
  routerDirection="forward"
>
  <div class="relative">
    <mtjr-blur-img
      proxy="https://dev-img.mtjr.ly/unsafe/resize:auto:400:400/sm:1/q:85/plain/"
      [src]="product().images?.[0] || 'https://nbg1.your-objectstorage.com/mtjr-prod/product-placeholder.webp'"
      [blurHash]="product().blurHash"
      alt="Photo of"
      [imgClass]="
        'aspect-square max-h-[220px] min-h-[160px] w-full z-100 ' +
        (isVoucherVendor() ? 'object-contain p-4' : 'object-cover')
      "
    />

    @if (!isVendorOwner) {
      <mtjr-heart-button class="absolute end-0 top-0 z-20" [productId]="product().id" />
    } @else {
      <div class="absolute end-2 top-2 z-50 bg-white/10 p-1 rounded-full flex items-center justify-center">
        @switch (product().publishStatus) {
          @case ("published") {
            <ion-icon
              color="success"
              name="checkmark-circle-outline"
              size="small"
              title="{{ 'PRODUCTS.PUBLISH_STATUS.PUBLISHED' | translate }}"
            />
          }
          @case ("waitingForReview") {
            <ion-icon
              color="warning"
              name="information-circle-outline"
              size="small"
              title="{{ 'PRODUCTS.PUBLISH_STATUS.WAITING_FOR_REVIEW' | translate }}"
            />
          }
          @case ("rejected") {
            <ion-icon
              color="danger"
              name="information-circle-outline"
              size="small"
              title="{{ 'PRODUCTS.PUBLISH_STATUS.REJECTED' | translate }}"
            />
          }
          @case ("unPublished") {
            <ion-icon
              color="danger"
              name="close-circle-outline"
              size="small"
              title="{{ 'PRODUCTS.PUBLISH_STATUS.UNPUBLISHED' | translate }}"
            />
          }
          @case ("draft") {
            <ion-icon
              color="medium"
              name="information-circle-outline"
              size="small"
              title="{{ 'PRODUCTS.PUBLISH_STATUS.DRAFT' | translate }}"
            />
          }
        }
      </div>
    }
  </div>

  <div class="flex flex-col px-4 pb-2 pt-2">
    <ion-text color="dark" class="text-md leading-[1.4]">{{ product().name }}</ion-text>

    <div class="mt-1.5 flex items-center">
      @if (priceRange(); as range) {
        <ion-text color="primary" class="text-md line-clamp-1 whitespace-nowrap">
          @if (range.min === range.max) {
            {{ range.max | vxCurrency }}
          } @else {
            <span class="hidden [html[lang='ar']_&]:block">
              {{ range.min | vxCurrency: true }} - {{ range.max | vxCurrency }}
            </span>
            <span class="hidden [html[lang='en']_&]:block">
              {{ range.min | vxCurrency }} - {{ range.max | vxCurrency: true }}
            </span>
          }
        </ion-text>
      } @else {
        <ion-text color="primary" class="me-2 text-[0.80rem]">
          {{ product().price | vxCurrency }}
        </ion-text>
        @if (product().discount) {
          <ion-text color="medium" class="text-sm line-through">
            {{ product().discount | vxCurrency }}
          </ion-text>
        }
      }
    </div>
  </div>
</ion-card>
